export default {
  AVAILABILITIES: `Availabilities`,
  LIST: {
    TITLE: `Availabilities list`,
    SUMMARY: ``
  },
  FORM: {
    TITLE: ``,
    SUMMARY: ``
  },
  CREATE: `Create an availability`,
  IMPORT_AVAILABILITIES: `Import availabilities`,
  IN_PROGRESS: `In progress`,
  APPROVAL_REQUIRED: `Pending approval`,
  APPROVE: `Approve`,
  APPROVED: `Approved`,
  CHANGES_REQUESTED: `Changes requested`,
  STATUS: `Status`,
  MANAGEMENT: `Management`,
  FIRST_COLUMN: ``,
  SECOND_COLUMN: ``,
  VALIDITY: `Validity`,
  VALIDATION_DATE: `Validated on`,
  LAST_UPDATED_DATE: `Updated on`,
  CREATED_BY_ON: `Created on {{date}} <1>{{time}}</1>`,
  LAST_UPDATE_ON: `Last updated on {{date}} <1>{{time}}</1>`,
  STATUS_PHRASE: `<0>{{status}}</0> by <1>{{validatedBy}}</1> on {{date}} <3>{{time}}</3>`,
  DATE_VALID: `Starts on <0>{{date}}</0>`,
  DATE_EXPIRED: `Expires on <0>{{date}}</0>`,
  TEMPORARY: `Temporary`,
  NOTES: `Notes`,
  ATTRIBUTES: `Attributes:`,
  DEPARTMENTS: `Departments:`,
  HIRING_DATA: `Hiring data:`,
  REGIONS: `Regions:`,
  NOT_SUBMITED_ENOUGH_IN_ADVANCE: `Not submitted enough in advance.`,
  AVAILABILITY_IN_PAST_WARNING: `This availability starts in the past. Creating or editing availabilities that start in the past can affect certain reports.`,
  COMMENT: `Comment:`,
  USER_DETAILS: `User details`,
  DELETE: {
    TITLE: `Delete the availability request`,
    SUMMARY: `Are you sure you want to delete the availability request?`,
    PRIMARY_ACTION: `Delete the request`
  },
  form: {
    CREATE: {
      TITLE: `Create an availability request`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Edit an availability request`,
      SUMMARY: ``
    },
    VIEW: {
      TITLE: `View an availability request`,
      SUMMARY: ``
    },
    DATEVALID: {
      LABEL: `Start Date`,
      DESCRIPTION: ``,
      TEMPORARY_DESCRIPTION: `This date must not be in the past.`
    },
    DATEEXPIRED: {
      LABEL: `End Date`,
      PLACEHOLDER: ``,
      DESCRIPTION: `This date must not be in the past and must be at least a week after the start date.`
    },
    NOTES: {
      LABEL: `Notes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Enter notes or additional information.`
    },
    TEMPORARY: {
      LABEL: `Set an end date`,
      DESCRIPTION: ``
    },
    REGULAR: {
      LABEL: `Repeats indefinitely`,
      DESCRIPTION: `This availability will repeat itself until the next availability starts.`
    },
    COPY_MODAL: {
      TITLE: `Copy/Paste Day`,
      PRIMARY_ACTION: `Apply`,
      SUMMARY: ``
    },
    USERID: {
      LABEL: `Employee`,
      DESCRIPTION: ``
    },
    APPROVALSTATUS: {
      LABEL: `Status`,
      DESCRIPTION: ``
    },
    EMPLOYEE_REQUIRED: `Employee is required`,
    NOTES_REQUIRED: `The notes field is mandatory.`,
    START_DATE_AFTER_TODAY: `The start date must be a future date.`,
    START_DATE_UNIQUE: `The start date must not be the same as any other availability start date.`,
    START_DATE_REQUIRED: `The start date field is mandatory.`,
    END_DATE_REQUIRED: `The end date field is mandatory.`,
    END_DATE_AFTER_START: `The end date must be at least a week after the start date.`,
    AVAILABILITY_STARTING_SAME_DAY: `The employee already has an existing availability starting on the same date.`,
    SAME_START: `The employee already has an existing availability starting on the same date.`,
    AVAILABLE_ALL_DAY: `Available`,
    UNAVAILABLE_ALL_DAY: `Unavailable`,
    UNAVAILABLE_FROM: `Unavailable from`,
    NOTE_FROM_MANAGER: `Note:`,
    NONE: `None`,
    COPY_TO_FOLLOWING: `Your availability for {{ day }} will be copied to the following day(s):`,
    SCHEDULE_TYPES: `Schedule types`
  },
  import: {
    TITLE: `Import availabilities`,
    SUMMARY: ``,
    EMPLOYEE_NUMBER: `Employee number`,
    EMPLOYEE_NAME: `Employee name`,
    STATUS: `Status`,
    EMPLOYEENUMBER_DESC: `The employee number found in the employee file in Merinio.`,
    DATEVALID: `Valid from`,
    DATEVALID_DESC: `Start date in <1>YYYY-MM-DD</1> format, for example January 30th 2010 would be <1>2010-01-30</1>. `,
    DATEEXPIRED: `Expire on`,
    DATEEXPIRED_DESC: `End date in the same format as start date.`,
    MONDAY: `Monday`,
    MONDAY_DESC: `By default, an employee is available all day long if no value is given. Write <1>U</1> for an all day unavailability. Availability range should be written in <1>AHH:mm-HH:mm</1> format, where <1>A08:00-16:00</1> represents an availability range from 8AM to 4PM. Use <1>U</1> instead of <1>A</1> for an unavailability range. To enter more than one value leave a space between each code, for example <1>A08:00-12:00</1> <1>U12:00-18:00</1>`,
    TUESDAY: `Tuesday`,
    TUESDAY_DESC: `Use the same format than monday.`,
    WEDNESDAY: `Wednesday`,
    WEDNESDAY_DESC: `Use the same format than monday.`,
    THURSDAY: `Thursday`,
    THURSDAY_DESC: `Use the same format than monday.`,
    FRIDAY: `Friday`,
    FRIDAY_DESC: `Use the same format than monday.`,
    SATURDAY: `Saturday`,
    SATURDAY_DESC: `Use the same format than monday.`,
    SUNDAY: `Sunday`,
    SUNDAY_DESC: `Use the same format than monday.`,
    DOWNLOAD_TEMPLATE: `Download template`,
    TEMPLATE_FILE_NAME: `availabilities_import`,
    MISSING_HEADERS: `Missing the following header: <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Missing the following headers: <0>{{value}}</0>`,
    AVAILABILITIES_SAVING_FAILED: `There was <0>{{count}}</0> availability that were not saved.`,
    AVAILABILITIES_SAVING_FAILED_other: `There were <0>{{count}}</0> availabilities that were not saved.`,
    AVAILABILITIES_NOT_VALID: `There was <0>{{count}}</0> invalid availability.`,
    AVAILABILITIES_NOT_VALID_other: `There were <0>{{count}}</0> invalid availabilities.`,
    ERROR_READING_CSV: `The file that was uploaded does not respect the proper CSV format, if your excel is in french, please change your delimiter settings.`,
    VALIDATION: `Validation`
  },
  ASK_FOR_CHANGES: `Ask for changes`,
  ASK_FOR_CHANGES_MODIFY_COMMENT: `Ask for changes (modify comment)`,
  REQUEST_CHANGES_MODAL: {
    TITLE: `Request changes in availability for {{fullName}}`,
    SUMMARY: ``,
    COMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Enter the comment`,
      DESCRIPTION: `The comment is used to inform the user what changes you would like in their availability request. The employee will be able to see the comment.`
    }
  },
  csv: {
    AVAILABILITIES_CSV_NAME: `availabilties_export_{{date}}`,
    FULLNAME: `Name`,
    EMPLOYEENUMBER: `Employee number`,
    DEPARTMENTS: `Departments`,
    STATUS: `Status`,
    DATEVALID: `Date valid`,
    CREATIONDATE: `Creation date`,
    CREATEDBY: `Created by`,
    LASTUPDATED: `Updated on`,
    LASTUPDATEBY: `Updated by`,
    VALIDATEDDATE: `Validated on`,
    VALIDATEDBYID: `Validated by`,
    AVAILABILITY_NAME: `Availability name`,
    COMMENT: `Comment`,
    NOTES: `Notes`,
    DATEEXPIRED: `Expiration date`,
    NOTSUBMITTEDENOUGHINADVANCE: `Not submitted enough in advance`
  }
}
